export default __webpack_public_path__ + "static/media/energy.81305156.png";